import { MULTI_ORDER_VALUE } from 'my-purchases/constants/constants'
import { PURCHASE_DETAIL_PATHNAME } from 'my-purchases/constants/paths'
import type { PriceToFormatProps } from 'my-purchases/hooks/useFormatPrice/useFormatPrice'
import type { FormattedPrices } from 'my-purchases/types/purchaseCommon'
import type { Purchase } from 'my-purchases/types/purchaseList'
import { getStatus } from 'my-purchases/utils/getStatus'
import type { CountryConfiguration } from 'types/countryConfiguration'
import { dateFormatter } from 'utils/dateFormatter/dateFormatter'

export const normalizeData = ({
	purchases,
	country,
	formatPrice,
}: {
	purchases: Purchase[]
	country: CountryConfiguration
	formatPrice: (props: PriceToFormatProps) => FormattedPrices
}) => {
	if (!Array.isArray(purchases)) {
		return null
	}

	const { locale } = country

	return purchases.map((purchase) => {
		const {
			purchaseId,
			creationDateTime,
			orders = [],
			active,
			paymentMethod,
			totalPrice,
			totalPriceAmount,
			totalPriceCurrency,
		} = purchase

		const firstOrder = orders[0]
		const { type, isMultiWarehouseTurkey } = firstOrder ?? {}
		const { lines } = firstOrder
		const { id, colorId } = lines?.[0] ?? {}

		const isMulti =
			(orders && orders.length >= MULTI_ORDER_VALUE) || isMultiWarehouseTurkey

		const articlesQuantity = orders.reduce((acc, item) => {
			return acc + item.orderLineCount
		}, 0)

		const link = `${PURCHASE_DETAIL_PATHNAME}?type=${type}&purchaseId=${purchaseId}`

		const statusFormatted = getStatus({
			type,
			orders,
			isMulti,
			paymentMethod,
			isActive: active,
		})

		return {
			...purchase,
			link,
			type,
			statusFormatted,
			articlesQuantity,
			date: dateFormatter({ dateString: creationDateTime, locale }),
			priceAmountFormatted: formatPrice({
				rawPrice: totalPriceAmount,
				formattedPrice: totalPrice,
				purchaseCurrency: totalPriceCurrency,
			}),
			orderIds: orders.map((order) => order.id),
			firstLineArticleImageId: id,
			firstLineColorId: colorId,
		}
	})
}
